import { useMemo, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function useDynamicFavicon() {
  const { pathname = '' } = useLocation()

  const faviconUrl = useMemo(() => {
    let faviconName = 'mp-favicon.ico'

    if (pathname.includes('/tms')) {
      faviconName = 'tms-favicon.ico'
    } else if (pathname.includes('/fms')) {
      faviconName = 'fms-favicon.ico'
    }

    return `${window.location.origin}/assets/${faviconName}`
  }, [pathname])

  /**
   * useEffect to update the favicon based on the user location.
   */
  useEffect(() => {
    let faviconLink = document.querySelector("link[rel~='icon']") as HTMLLinkElement

    if (!faviconLink) {
      faviconLink = document.createElement('link')
      faviconLink.rel = 'icon'

      document.head.appendChild(faviconLink)
    }

    faviconLink.href = faviconUrl
  }, [faviconUrl])
}
